import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TrainingSessionCompany } from '../../../../../../_services/session/company';

@Component({
    selector: 'registration-financing-edition',
    templateUrl: 'financing-edition.component.html',
    styleUrls: [
        '../../registration.component.scss',
        '../../../../../_shared/label/label.component.scss',
    ],
    providers: [],
})
export class SessionFinancingEditionComponent implements OnInit {
    @Input() tsCompany: TrainingSessionCompany;

    ngOnInit() {}

    onFinancedChange(event) {
        if (!event.target.checked) {
            this.tsCompany.financingCompany = '';
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/session/detail/registration/registration-company/financing-edition/financing-edition.component.ts